import styled from "styled-components"

export default styled.div`
  min-width: 0;
  padding: 1rem;
`



// WEBPACK FOOTER //
// ./src/components/Subcontainer.js